/* tslint:disable */
/* eslint-disable */
/**
 * CMS
 * The CMS API description
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { AxiosResponse, AxiosInstance, AxiosRequestConfig } from "axios";
// @ts-ignore
import globalAxios from "@/config/axiosInstance";
import { Configuration } from "../configuration";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "../base";
import { RemoveCategoryDTO } from "../models";
/**
 * CategoryApi - axios parameter creator
 * @export
 */
export const CategoryApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} name
     * @param {string} altName
     * @param {string} slug
     * @param {number} status
     * @param {string} parent
     * @param {string} desc
     * @param {Array} children
     * @param {Array} coverTypes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoryControllerCreateCategoryForm: async (
      name: string,
      altName: string,
      slug: string,
      status: number,
      parent: string,
      desc: string,
      children: Array,
      coverTypes: Array,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'name' is not null or undefined
      if (name === null || name === undefined) {
        throw new RequiredError(
          "name",
          "Required parameter name was null or undefined when calling categoryControllerCreateCategoryForm."
        );
      }
      // verify required parameter 'altName' is not null or undefined
      if (altName === null || altName === undefined) {
        throw new RequiredError(
          "altName",
          "Required parameter altName was null or undefined when calling categoryControllerCreateCategoryForm."
        );
      }
      // verify required parameter 'slug' is not null or undefined
      if (slug === null || slug === undefined) {
        throw new RequiredError(
          "slug",
          "Required parameter slug was null or undefined when calling categoryControllerCreateCategoryForm."
        );
      }
      // verify required parameter 'status' is not null or undefined
      if (status === null || status === undefined) {
        throw new RequiredError(
          "status",
          "Required parameter status was null or undefined when calling categoryControllerCreateCategoryForm."
        );
      }
      // verify required parameter 'parent' is not null or undefined
      if (parent === null || parent === undefined) {
        throw new RequiredError(
          "parent",
          "Required parameter parent was null or undefined when calling categoryControllerCreateCategoryForm."
        );
      }
      // verify required parameter 'desc' is not null or undefined
      if (desc === null || desc === undefined) {
        throw new RequiredError(
          "desc",
          "Required parameter desc was null or undefined when calling categoryControllerCreateCategoryForm."
        );
      }
      // verify required parameter 'children' is not null or undefined
      if (children === null || children === undefined) {
        throw new RequiredError(
          "children",
          "Required parameter children was null or undefined when calling categoryControllerCreateCategoryForm."
        );
      }
      // verify required parameter 'coverTypes' is not null or undefined
      if (coverTypes === null || coverTypes === undefined) {
        throw new RequiredError(
          "coverTypes",
          "Required parameter coverTypes was null or undefined when calling categoryControllerCreateCategoryForm."
        );
      }
      const localVarPath = `/v1/cms/api/category`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new FormData();

      if (name !== undefined) {
        localVarFormParams.append("name", name as any);
      }

      if (altName !== undefined) {
        localVarFormParams.append("altName", altName as any);
      }

      if (slug !== undefined) {
        localVarFormParams.append("slug", slug as any);
      }

      if (status !== undefined) {
        localVarFormParams.append("status", status as any);
      }

      if (parent !== undefined) {
        localVarFormParams.append("parent", parent as any);
      }

      if (desc !== undefined) {
        localVarFormParams.append("desc", desc as any);
      }

      if (children !== undefined) {
        localVarFormParams.append("children", children as any);
      }

      if (coverTypes !== undefined) {
        localVarFormParams.append("coverTypes", coverTypes as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";
      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} [name]
     * @param {string} [parent]
     * @param {boolean} [justParent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoryControllerGetCategory: async (
      pageNumber: number,
      pageIndex: number,
      name?: string,
      parent?: string,
      justParent?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'pageNumber' is not null or undefined
      if (pageNumber === null || pageNumber === undefined) {
        throw new RequiredError(
          "pageNumber",
          "Required parameter pageNumber was null or undefined when calling categoryControllerGetCategory."
        );
      }
      // verify required parameter 'pageIndex' is not null or undefined
      if (pageIndex === null || pageIndex === undefined) {
        throw new RequiredError(
          "pageIndex",
          "Required parameter pageIndex was null or undefined when calling categoryControllerGetCategory."
        );
      }
      const localVarPath = `/v1/cms/api/category`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (pageNumber !== undefined) {
        localVarQueryParameter["pageNumber"] = pageNumber;
      }

      if (pageIndex !== undefined) {
        localVarQueryParameter["pageIndex"] = pageIndex;
      }

      if (name !== undefined) {
        localVarQueryParameter["name"] = name;
      }

      if (parent !== undefined) {
        localVarQueryParameter["parent"] = parent;
      }

      if (justParent !== undefined) {
        localVarQueryParameter["justParent"] = justParent;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} filename
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoryControllerGetUserMedia: async (
      filename: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'filename' is not null or undefined
      if (filename === null || filename === undefined) {
        throw new RequiredError(
          "filename",
          "Required parameter filename was null or undefined when calling categoryControllerGetUserMedia."
        );
      }
      const localVarPath = `/v1/cms/api/category-media/{filename}`.replace(
        `{${"filename"}}`,
        encodeURIComponent(String(filename))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {RemoveCategoryDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoryControllerRemoveCategory: async (
      body: RemoveCategoryDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling categoryControllerRemoveCategory."
        );
      }
      const localVarPath = `/v1/cms/api/category`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || "";

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} name
     * @param {string} altName
     * @param {number} status
     * @param {string} parent
     * @param {string} desc
     * @param {Array} children
     * @param {Array} coverTypes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoryControllerUpdateCategoryForm: async (
      name: string,
      altName: string,
      status: number,
      parent: string,
      desc: string,
      children: Array,
      coverTypes: Array,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'name' is not null or undefined
      if (name === null || name === undefined) {
        throw new RequiredError(
          "name",
          "Required parameter name was null or undefined when calling categoryControllerUpdateCategoryForm."
        );
      }
      // verify required parameter 'altName' is not null or undefined
      if (altName === null || altName === undefined) {
        throw new RequiredError(
          "altName",
          "Required parameter altName was null or undefined when calling categoryControllerUpdateCategoryForm."
        );
      }
      // verify required parameter 'status' is not null or undefined
      if (status === null || status === undefined) {
        throw new RequiredError(
          "status",
          "Required parameter status was null or undefined when calling categoryControllerUpdateCategoryForm."
        );
      }
      // verify required parameter 'parent' is not null or undefined
      if (parent === null || parent === undefined) {
        throw new RequiredError(
          "parent",
          "Required parameter parent was null or undefined when calling categoryControllerUpdateCategoryForm."
        );
      }
      // verify required parameter 'desc' is not null or undefined
      if (desc === null || desc === undefined) {
        throw new RequiredError(
          "desc",
          "Required parameter desc was null or undefined when calling categoryControllerUpdateCategoryForm."
        );
      }
      // verify required parameter 'children' is not null or undefined
      if (children === null || children === undefined) {
        throw new RequiredError(
          "children",
          "Required parameter children was null or undefined when calling categoryControllerUpdateCategoryForm."
        );
      }
      // verify required parameter 'coverTypes' is not null or undefined
      if (coverTypes === null || coverTypes === undefined) {
        throw new RequiredError(
          "coverTypes",
          "Required parameter coverTypes was null or undefined when calling categoryControllerUpdateCategoryForm."
        );
      }
      const localVarPath = `/v1/cms/api/category`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new FormData();

      if (name !== undefined) {
        localVarFormParams.append("name", name as any);
      }

      if (altName !== undefined) {
        localVarFormParams.append("altName", altName as any);
      }

      if (status !== undefined) {
        localVarFormParams.append("status", status as any);
      }

      if (parent !== undefined) {
        localVarFormParams.append("parent", parent as any);
      }

      if (desc !== undefined) {
        localVarFormParams.append("desc", desc as any);
      }

      if (children !== undefined) {
        localVarFormParams.append("children", children as any);
      }

      if (coverTypes !== undefined) {
        localVarFormParams.append("coverTypes", coverTypes as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";
      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CategoryApi - functional programming interface
 * @export
 */
export const CategoryApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} name
     * @param {string} altName
     * @param {string} slug
     * @param {number} status
     * @param {string} parent
     * @param {string} desc
     * @param {Array} children
     * @param {Array} coverTypes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categoryControllerCreateCategoryForm(
      name: string,
      altName: string,
      slug: string,
      status: number,
      parent: string,
      desc: string,
      children: Array,
      coverTypes: Array,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await CategoryApiAxiosParamCreator(
        configuration
      ).categoryControllerCreateCategoryForm(
        name,
        altName,
        slug,
        status,
        parent,
        desc,
        children,
        coverTypes,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} [name]
     * @param {string} [parent]
     * @param {boolean} [justParent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categoryControllerGetCategory(
      pageNumber: number,
      pageIndex: number,
      name?: string,
      parent?: string,
      justParent?: boolean,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await CategoryApiAxiosParamCreator(
        configuration
      ).categoryControllerGetCategory(
        pageNumber,
        pageIndex,
        name,
        parent,
        justParent,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} filename
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categoryControllerGetUserMedia(
      filename: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await CategoryApiAxiosParamCreator(
        configuration
      ).categoryControllerGetUserMedia(filename, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {RemoveCategoryDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categoryControllerRemoveCategory(
      body: RemoveCategoryDTO,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await CategoryApiAxiosParamCreator(
        configuration
      ).categoryControllerRemoveCategory(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} name
     * @param {string} altName
     * @param {number} status
     * @param {string} parent
     * @param {string} desc
     * @param {Array} children
     * @param {Array} coverTypes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categoryControllerUpdateCategoryForm(
      name: string,
      altName: string,
      status: number,
      parent: string,
      desc: string,
      children: Array,
      coverTypes: Array,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await CategoryApiAxiosParamCreator(
        configuration
      ).categoryControllerUpdateCategoryForm(
        name,
        altName,
        status,
        parent,
        desc,
        children,
        coverTypes,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * CategoryApi - factory interface
 * @export
 */
export const CategoryApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @param {string} name
     * @param {string} altName
     * @param {string} slug
     * @param {number} status
     * @param {string} parent
     * @param {string} desc
     * @param {Array} children
     * @param {Array} coverTypes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categoryControllerCreateCategoryForm(
      name: string,
      altName: string,
      slug: string,
      status: number,
      parent: string,
      desc: string,
      children: Array,
      coverTypes: Array,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return CategoryApiFp(configuration)
        .categoryControllerCreateCategoryForm(
          name,
          altName,
          slug,
          status,
          parent,
          desc,
          children,
          coverTypes,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} [name]
     * @param {string} [parent]
     * @param {boolean} [justParent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categoryControllerGetCategory(
      pageNumber: number,
      pageIndex: number,
      name?: string,
      parent?: string,
      justParent?: boolean,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return CategoryApiFp(configuration)
        .categoryControllerGetCategory(
          pageNumber,
          pageIndex,
          name,
          parent,
          justParent,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} filename
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categoryControllerGetUserMedia(
      filename: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return CategoryApiFp(configuration)
        .categoryControllerGetUserMedia(filename, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {RemoveCategoryDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categoryControllerRemoveCategory(
      body: RemoveCategoryDTO,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return CategoryApiFp(configuration)
        .categoryControllerRemoveCategory(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} name
     * @param {string} altName
     * @param {number} status
     * @param {string} parent
     * @param {string} desc
     * @param {Array} children
     * @param {Array} coverTypes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categoryControllerUpdateCategoryForm(
      name: string,
      altName: string,
      status: number,
      parent: string,
      desc: string,
      children: Array,
      coverTypes: Array,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return CategoryApiFp(configuration)
        .categoryControllerUpdateCategoryForm(
          name,
          altName,
          status,
          parent,
          desc,
          children,
          coverTypes,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * CategoryApi - object-oriented interface
 * @export
 * @class CategoryApi
 * @extends {BaseAPI}
 */
export class CategoryApi extends BaseAPI {
  /**
   *
   * @param {string} name
   * @param {string} altName
   * @param {string} slug
   * @param {number} status
   * @param {string} parent
   * @param {string} desc
   * @param {Array} children
   * @param {Array} coverTypes
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoryApi
   */
  public async categoryControllerCreateCategoryForm(
    name: string,
    altName: string,
    slug: string,
    status: number,
    parent: string,
    desc: string,
    children: Array,
    coverTypes: Array,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return CategoryApiFp(this.configuration)
      .categoryControllerCreateCategoryForm(
        name,
        altName,
        slug,
        status,
        parent,
        desc,
        children,
        coverTypes,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {number} pageNumber
   * @param {number} pageIndex
   * @param {string} [name]
   * @param {string} [parent]
   * @param {boolean} [justParent]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoryApi
   */
  public async categoryControllerGetCategory(
    pageNumber: number,
    pageIndex: number,
    name?: string,
    parent?: string,
    justParent?: boolean,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return CategoryApiFp(this.configuration)
      .categoryControllerGetCategory(
        pageNumber,
        pageIndex,
        name,
        parent,
        justParent,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} filename
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoryApi
   */
  public async categoryControllerGetUserMedia(
    filename: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return CategoryApiFp(this.configuration)
      .categoryControllerGetUserMedia(filename, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {RemoveCategoryDTO} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoryApi
   */
  public async categoryControllerRemoveCategory(
    body: RemoveCategoryDTO,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return CategoryApiFp(this.configuration)
      .categoryControllerRemoveCategory(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} name
   * @param {string} altName
   * @param {number} status
   * @param {string} parent
   * @param {string} desc
   * @param {Array} children
   * @param {Array} coverTypes
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoryApi
   */
  public async categoryControllerUpdateCategoryForm(
    name: string,
    altName: string,
    status: number,
    parent: string,
    desc: string,
    children: Array,
    coverTypes: Array,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return CategoryApiFp(this.configuration)
      .categoryControllerUpdateCategoryForm(
        name,
        altName,
        status,
        parent,
        desc,
        children,
        coverTypes,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
